/* eslint-disable */
import { CSSTransition, SwitchTransition } from 'react-transition-group';

interface IDefaultCSSTransition {
  children?: JSX.Element;
  inState?: boolean;
  inSwitch?: any;
  fromTo?: 'bottom' | 'top';
}

const defaultCSSOptions = {
  timeout: {
    appear: 260,
    enter: 160,
    exit: 160,
  },
  classNames: {
    enter: 'on-enter',
    enterActive: 'on-enter-active',
    exit: 'on-exit',
    exitActive: 'on-exit-active',
  },
};

function DefaultCSSTransition({
  children,
  inState,
  inSwitch,
  fromTo = 'bottom',
}: IDefaultCSSTransition) {
  return (
    <>
      {inSwitch ? (
        <SwitchTransition>
          <CSSTransition {...defaultCSSOptions} in={!!inSwitch} key={inSwitch}>
            {children}
          </CSSTransition>
        </SwitchTransition>
      ) : (
        <CSSTransition
          {...defaultCSSOptions}
          unmountOnExit={true}
          in={inState}
          classNames={{
            enter: fromTo === 'top' ? 'on-enter-top' : 'on-enter',
            enterActive: 'on-enter-active',
            exit: 'on-exit',
            exitActive: fromTo === 'top' ? 'on-exit-top-active' : 'on-exit-active',
          }}
        >
          {children}
        </CSSTransition>
      )}
    </>
  );
}

export default DefaultCSSTransition;
